import * as React from "react";
import { ContentFramingContent } from "./components/ContentFramingContent";

export default function ContentFraming() {
  return (
    <div className="w-full h-full min-h-screen flex items-start justify-center bg-gray-100">
      <div className="w-full">
        <ContentFramingContent />
      </div>
    </div>
  );
}



